<template>
	<!-- Modal: Cart is Full -->
	<div :class="modal ? 'modal is-active' : 'modal'">
		<div class="modal-background"></div>
		<div class="modal-card is-small">
			<header class="modal-card-head">
				<button @click.prevent="closeModal()" class="delete" aria-label="close"></button>
				<p class="modal-card-title">Cart is Full</p>
			</header>
			<section class="modal-card-body has-text-centered ph20">
				<img class="has-text-centered mt15 mb20" src="@/assets/img/icon-bucket.png" alt="Empty">
				<div class="sf-pro-text-medium mb15 modal-text"><span class="excess-quantity">{{ parseFloat(overWeight).toFixed(2) }}g</span> / {{ vg_cannabisLimit }}g limit
				</div>
				<p class="has-text-centered is-size-14 modal-text">Sorry! This item cannot be added<br>because it
					exceeds the max {{ vg_cannabisLimit }}g limit.</p>
			</section>
			<footer class="modal-card-foot is-flex-column">
	      <button @click.prevent="closeModal()" class="button is-large is-primary is-full-width mr0 mb20">Close</button>
			</footer>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: 'CartLimitExceed',
  data() {
    return {
      modal: false,
      overWeight: 0,
    };
  },
  computed: {
    ...mapGetters({
      vg_cannabisLimit: "location/cannabis_limit",
    }),
  },
  
  mounted() {
    bus.$on('show-modal-cart-limit-exceed', (payload) => {
      this.modal = payload.modal;
      this.overWeight = payload.overWeight;
    })
  },

  beforeDestroy() {
    bus.$off('show-modal-cart-limit-exceed');
  },

  methods: {
   closeModal() {
     this.modal = false;
   },
   gotoCart() {
     this.closeModal();
     //this.$router.push({ name: 'Cart'})
   }
  },
};
</script>